export default function EmptyState({ message = 'All systems quiet. Watching.', symbol = '◈' }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '60px 20px', gap: 16,
    }}>
      <span style={{
        fontSize: 48, color: 'var(--olv-purple)',
        fontFamily: 'var(--font-brand)', fontWeight: 700,
        animation: 'olv-breathe 4s ease-in-out infinite',
      }}>
        {symbol}
      </span>
      <span style={{
        fontSize: 13, color: 'var(--olv-text-secondary)',
        fontFamily: 'var(--font-body)', letterSpacing: '0.02em',
      }}>
        {message}
      </span>
    </div>
  )
}
